import { Query, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { isInternalQueryKey } from '@lifeomic/one-query/util';
import { TemplatingItem } from '../models';

export const useInvalidateTemplatingItemQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (...templatingItems: TemplatingItem[]) =>
      Promise.all(
        templatingItems.map(templatingItem => {
          queryClient.invalidateQueries({
            predicate: getPredicate(templatingItem),
          });
        }),
      ),
    [queryClient],
  );
};

export const useResetTemplatingItemQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (...templatingItems: TemplatingItem[]) =>
      Promise.all(
        templatingItems.map(templatingItem => {
          queryClient.resetQueries({
            predicate: getPredicate(templatingItem),
          });
        }),
      ),
    [queryClient],
  );
};

function getPredicate(templatingItem: TemplatingItem) {
  return (query: Query) => {
    const internalQueryKey = query.queryKey.find(isInternalQueryKey);
    if (!internalQueryKey) {
      return false;
    }
    if (internalQueryKey.route === 'GET /v1/ai-templates/:id') {
      const payload = internalQueryKey.payload as { id: string };
      return payload.id === templatingItem.id;
    } else if (
      internalQueryKey.route === 'GET /v1/ai-templates/durable/:durableId'
    ) {
      const payload = internalQueryKey.payload as {
        durableId: string;
      };
      return payload.durableId === templatingItem.durableId;
    }
    return false;
  };
}
